import { useEffect, useRef } from 'react';

export default function Cursor() {
  const dotRef  = useRef(null);
  const ringRef = useRef(null);
  const posRef  = useRef({ x: 0, y: 0 });
  const ringPos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const dot  = dotRef.current;
    const ring = ringRef.current;
    const onMove = e => {
      posRef.current = { x: e.clientX, y: e.clientY };
      dot.style.left = e.clientX + 'px';
      dot.style.top  = e.clientY + 'px';
    };
    const onDown = () => { dot.style.transform = 'translate(-50%,-50%) scale(0.7)'; };
    const onUp   = () => { dot.style.transform = 'translate(-50%,-50%) scale(1)'; };
    const onEnter = () => { ring.style.width = '52px'; ring.style.height = '52px'; ring.style.borderColor = 'rgba(139,109,56,0.6)'; };
    const onLeave = () => { ring.style.width = '36px'; ring.style.height = '36px'; ring.style.borderColor = 'rgba(139,109,56,0.3)'; };

    document.querySelectorAll('button,a,[data-cursor]').forEach(el => {
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mouseleave', onLeave);
    });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mousedown', onDown);
    window.addEventListener('mouseup', onUp);

    let raf;
    const lerp = (a, b, t) => a + (b - a) * t;
    const animate = () => {
      ringPos.current.x = lerp(ringPos.current.x, posRef.current.x, 0.1);
      ringPos.current.y = lerp(ringPos.current.y, posRef.current.y, 0.1);
      ring.style.left = ringPos.current.x + 'px';
      ring.style.top  = ringPos.current.y + 'px';
      raf = requestAnimationFrame(animate);
    };
    animate();
    return () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mousedown', onDown); window.removeEventListener('mouseup', onUp); cancelAnimationFrame(raf); };
  }, []);

  return (
    <>
      <style>{`
        .cur-dot {
          position:fixed; width:9px; height:9px;
          background:var(--gold); border-radius:50%;
          pointer-events:none; z-index:99999;
          transform:translate(-50%,-50%);
          transition:transform 0.2s;
        }
        .cur-ring {
          position:fixed; width:36px; height:36px;
          border:1.5px solid rgba(139,109,56,0.3);
          border-radius:50%;
          pointer-events:none; z-index:99998;
          transform:translate(-50%,-50%);
          transition:width 0.3s, height 0.3s, border-color 0.3s;
        }
        @media(hover:none){ .cur-dot,.cur-ring{ display:none; } }
      `}</style>
      <div className="cur-dot"  ref={dotRef}  />
      <div className="cur-ring" ref={ringRef} />
    </>
  );
}
